import { useIntl } from 'react-intl';
import type { Content } from '@plone/types';
import {
  NormalizableContent,
  transformToCard,
} from '@fhnw/helpers/DesignSystem/cardTransformers';
import { Card as DSCard } from '@designsystem/stories/03-molecules/Card';
import type { CardProps as DSCardProps } from '@designsystem/stories/03-molecules/Card';

export interface CardProps {
  content?: Content;
  card?: DSCardProps;
  showText?: boolean;
  showImage?: boolean;
  className?: string;
  type?: DSCardProps['type'];
}

const Card = ({
  content,
  card,
  showText = true,
  showImage = true,
  className,
  type,
}: CardProps) => {
  const intl = useIntl();

  if (!content && !card) {
    return null;
  }

  const normalized = {
    ...(card ?? transformToCard(content as NormalizableContent, intl, type)),
  };

  if (!showText && normalized?.description) {
    delete normalized.description;
  }

  if (!showImage && normalized?.image) {
    delete normalized.image;
  }

  return <DSCard className={className} {...normalized} />;
};

export default Card;
